import { directionExposureLabels } from '@/utils/capitalRuleFormatters';
import React from 'react';
import Card from '@/components/UI/Card';
import Button from '@/components/UI/Button';
import { DeleteButton, EditButton, EmptyState } from '@/components/UI';
import type { DirectionMaxRule } from '@einhaus/project314-types';

interface DirectionalRulesCardProps {
    rules: DirectionMaxRule[];
    onDeleteRule: (ruleId: string, type: 'directionMax' | 'categoryLimit' | 'positionSizeRule') => void;
    setEditingRuleId: React.Dispatch<React.SetStateAction<string | null>>;
    setNewRule: React.Dispatch<React.SetStateAction<Partial<DirectionMaxRule>>>;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const DirectionalRulesCard: React.FC<DirectionalRulesCardProps> = ({ rules, onDeleteRule, setEditingRuleId, setNewRule, setShowModal }) => (
    <Card className="mb-4" headerClassName="flex justify-between items-center" title="Underlying Exposure Limits">
        <Button
            variant="link"
            onClick={() => {
                setEditingRuleId(null);

                setNewRule({
                    direction: 'either',
                    type: 'positions',
                    value: 0
                });

                setShowModal(true);
            }}
        >
            + Add
        </Button>

        {rules.length === 0 ? (
            <EmptyState size="sm" title="No underlying exposure limit rules configured." />
        ) : (
            <div className="overflow-x-auto">
                <table className="min-w-full bg-zinc-800 text-white border-collapse">
                    <thead>
                        <tr className="bg-zinc-700">
                            <th className="px-4 py-2 text-left">Type</th>
                            <th className="px-4 py-2 text-left">Underlying exposure</th>
                            <th className="px-4 py-2 text-left">Maximum Value</th>
                            <th className="px-4 py-2 text-left">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rules.map((rule, index) => (
                            <tr className={index % 2 === 0 ? 'bg-zinc-800' : 'bg-zinc-750'} key={rule.id}>
                                <td className="px-4 py-2 border-t border-zinc-700">{rule.type}</td>
                                <td className="px-4 py-2 border-t border-zinc-700">{directionExposureLabels[rule.direction]}</td>
                                <td className="px-4 py-2 border-t border-zinc-700">{rule.value}</td>
                                <td className="px-4 py-2 border-t border-zinc-700">
                                    <div className="flex items-center gap-2">
                                        <EditButton
                                            size="sm"
                                            onClick={() => {
                                                setEditingRuleId(rule.id);

                                                setNewRule({
                                                    direction: rule.direction,
                                                    type: rule.type,
                                                    value: rule.value
                                                });

                                                setShowModal(true);
                                            }}
                                        />
                                        <DeleteButton size="sm" onClick={() => onDeleteRule(rule.id, 'directionMax')} />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        )}
    </Card>
);

export default DirectionalRulesCard;
